import './tooltip.css';

const InfoTooltip = ({ text }) => (
    <div className="tooltip-container">
        <span className="info-icon">i</span>
        <div className="tooltip-text">{text}</div>
    </div>
);

export default InfoTooltip;